import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "withdraw_container" }
const _hoisted_2 = { class: "channel_container" }
const _hoisted_3 = { class: "channel_text" }
const _hoisted_4 = { class: "channel_list" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "channel_container" }
const _hoisted_8 = { style: {"padding":"0 10px"} }
const _hoisted_9 = { class: "fee-total-row" }
const _hoisted_10 = { class: "fee-text" }
const _hoisted_11 = { class: "highlight" }
const _hoisted_12 = { class: "total-text" }
const _hoisted_13 = { class: "highlight" }
const _hoisted_14 = {
  key: 0,
  class: "withdrawNotice"
}
const _hoisted_15 = { class: "channel_container" }
const _hoisted_16 = { class: "btn_container" }
const _hoisted_17 = {
  key: 2,
  class: "descriptionContainer"
}
const _hoisted_18 = { class: "noticeText" }

import { ref, computed, onMounted, reactive } from 'vue'
import InputField from '../withdraw/components/inputField.vue';
import { PayChannel } from '@/types/common';
import { formatCurrency } from '@/utils/commonFunction';
import { Channel, TAB_TYPE_LIST, WithdrawPopupData, WithdrawViewData } from '@/view/withdraw/supportScript';
import WithdrawViewTwo from './withdrawPopup.vue';
import { useWithdrawStore } from '@/stores/withdraw';
import { useUserStore } from '@/stores/user';
import { withdraw, withdrawSettingByUserID } from '@/api/withdraw';
import MainButton from '../components/common/mainButton.vue';
import CryptoWithdraw from './cryptoWithdraw.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'withdrawView',
  props: {
    dataSet: {}
  },
  emits: ['selectChannel', 'showError', 'showSuccess', 'showLoading', 'inputValueChange'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const withdrawStore = useWithdrawStore()
const userStore = useUserStore()
const uId = computed(() => userStore.id)
const props = __props
const withdrawRef = ref<InstanceType<typeof WithdrawViewTwo>>()
const selectedChannel = computed(() => withdrawStore.selectedChannel as Channel)
const activeTab = ref(TAB_TYPE_LIST[0])
const cpfID = ref('')
const emailID = ref('')
const phoneID = ref('')
const evpID = ref('')
const userName = ref('')
const cpfNumber = ref('')
const brazilID = ref('')
const bank = ref('')
const showCPFIdError = ref(false)
const showEmaiIdError = ref(false)
const showPhoneIdError = ref(false)
const showEvpIdError = ref(false)
const showCPFNumError = ref(false)
const activeButton = ref(false)
const isActiveButton = ref(false)
const selectedAmount = ref(0)
const isDisabled = ref(false)

const formValues = ref({
    cpfID: '',
    emailID: '',
    phoneID: '',
    evpID: '',
    userName: '',
    cpfNumber: '',
    brazilID: '',
    bank: '',
})

const dataSetTwo = reactive<WithdrawPopupData>({
    // show: show.value,
    selectedChannel: selectedChannel.value,
    activeTab: activeTab.value,
    cpfID: cpfID.value,
    emailID: emailID.value,
    phoneID: phoneID.value,
    evpID: evpID.value,
    userName: userName.value,
    cpfNumber: cpfNumber.value,
    brazilID: brazilID.value,
    bank: bank.value,
    showCPFIdError: showCPFIdError.value,
    showEmaiIdError: showEmaiIdError.value,
    showPhoneIdError: showPhoneIdError.value,
    showEvpIdError: showEvpIdError.value,
    showCPFNumError: showCPFNumError.value,
    activeButton: activeButton.value,
    selectedAmount: selectedAmount.value,
    isDisabled: isDisabled.value,
})

const isMainButtonActive = computed(() => props.dataSet.activeButton && isActiveButton.value)

const updateWithdrawFormValues = (values: any) => {
    formValues.value = { ...formValues.value, ...values }
}

const selectChannel = (item: PayChannel) => {
    emits('selectChannel', item)
}



const selectTabType = (item: any) => {
    activeTab.value = item
}

const confirmWithdrawUserId = () => {
    const data = { uid: uId.value }
    withdrawSettingByUserID(data)
        .then((res) => {
            confirmWithdrawApi()
        })
        .catch((err) => {
            if (err.code != 401) {
                emits('showError', err)
            }
        })
}

const confirmWithdrawApi = () => {
    emits('showLoading', true)
    const active = activeTab.value.name

    const data: any = {
        payment_channel_id: selectedChannel.value.id,
        amount: props.dataSet.selectedAmount,
        tax_type: active,
        tax_id:
            active === 'CPF'
                ? formValues.value.cpfID
                : active === 'E-mail'
                    ? formValues.value.emailID
                    : active === 'PHONE'
                        ? formValues.value.phoneID
                        : active === 'EVP'
                            ? formValues.value.evpID
                            : '',
        account_name: formValues.value.userName,
        cpf_id: formValues.value.cpfNumber,
        uid: uId.value,
    }

    if (selectedChannel.value.channelType === '1') {
        data.bank_name = formValues.value.bank
    } else if (selectedChannel.value.channelType === '7') {
        data.bank_name = formValues.value.bank
        data.identity_no = formValues.value.brazilID
    }

    withdraw(data)
        .then((res) => {
            emits('showLoading', false)
            emits('showSuccess', res.msg)
            setTimeout(() => {
                userStore.getInfo()
            }, 500)
        })
        .catch((err) => {
            emits('showLoading', false)
            emits('showError', err)
            setTimeout(() => {
                userStore.getInfo()
            }, 500)
        })
}

const getWithdrawDetails = () => {
    let data = { uid: uId.value }
    withdrawSettingByUserID(data)
        .then(res => {
            const resData = res.data
            if (resData == null) return
            withdrawStore.setWithdrawInfo(resData)
            dataSetTwo.cpfID = resData?.cpf || ''
            dataSetTwo.emailID = resData?.email || ''
            dataSetTwo.phoneID = resData?.phone || ''
            dataSetTwo.evpID = resData?.evpId || ''
            dataSetTwo.userName = resData?.userName || ''
            dataSetTwo.cpfNumber = resData?.cpfId || ''
            dataSetTwo.brazilID = resData?.identityNo || ''
            dataSetTwo.isDisabled = resData?.isEditable == 1
        })
        .catch((err) => {
            if (err.code != 401) {
                emits('showError', err)
            }
        })
}

const changeValues = (data: any) => {
    if (data.type === 'cpfID') {
        cpfID.value = data.value
    } else if (data.type === 'emailID') {
        emailID.value = data.value
    } else if (data.type === 'phoneID') {
        phoneID.value = data.value
    } else if (data.type === 'evpID') {
        evpID.value = data.value
    } else if (data.type === 'cpfNumber') {
        cpfNumber.value = data.value
    } else if (data.type === 'userName') {
        userName.value = data.value
    } else if (data.type === 'brazilID') {
        brazilID.value = data.value
    } else if (data.type === 'bank') {
        bank.value = data.value
    }
}

const checkFieldsFill = (isActive: any) => {
    isActiveButton.value = isActive
}


const inputValueChange = (value: any) => {
    emits('inputValueChange', value)
}

onMounted(() => {
    getWithdrawDetails()
})

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('common.paymentChannel')) + "：", 1),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.channelList, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["channel_card", _ctx.dataSet.activeChannel.id == item.id ? 'active_channel' : '']),
            key: item.name,
            onClick: ($event: any) => (selectChannel(item))
          }, _toDisplayString(item.name), 11, _hoisted_5))
        }), 128))
      ])
    ]),
    (_ctx.dataSet.activeChannel.channelType == '6')
      ? (_openBlock(), _createBlock(CryptoWithdraw, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(InputField, {
                modelValue: _ctx.dataSet?.selectedAmount,
                labelText: _ctx.$t('withdraw.valueLabel'),
                onValueChanged: inputValueChange
              }, null, 8, ["modelValue", "labelText"]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, [
                  _createTextVNode(_toDisplayString(_ctx.$t('withdraw.withdrawFee')) + ": ", 1),
                  _cache[2] || (_cache[2] = _createElementVNode("span", { class: "currency" }, "R$", -1)),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(formatCurrency)(_ctx.dataSet?.selectedAmount || 0)), 1)
                ]),
                _createElementVNode("span", _hoisted_12, [
                  _createTextVNode(_toDisplayString(_ctx.$t('withdraw.totalToReceive')) + ": ", 1),
                  _cache[3] || (_cache[3] = _createElementVNode("span", { class: "currency" }, "R$", -1)),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(formatCurrency)(_ctx.dataSet?.balanceAmount || 0)), 1)
                ])
              ]),
              (_ctx.dataSet?.remainingTurnOver > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createVNode(_component_van_icon, {
                      name: "info-o",
                      color: "#ffffff87",
                      size: "14"
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('withdraw.betMoreNotice', { value: _unref(formatCurrency)(_ctx.dataSet?.remainingTurnOver) })), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(WithdrawViewTwo, {
              ref_key: "withdrawRef",
              ref: withdrawRef,
              "data-set-two": dataSetTwo,
              "onUpdate:dataSetTwo": _cache[0] || (_cache[0] = ($event: any) => ((dataSetTwo) = $event)),
              onConfirmWithdrawPopup: confirmWithdrawUserId,
              onInputValueChange: inputValueChange,
              onSelectChannel: selectChannel,
              onSelectTabType: selectTabType,
              onUpdateFormValues: updateWithdrawFormValues,
              onChangeValue: changeValues,
              onCheckFieldsFill: checkFieldsFill
            }, null, 8, ["data-set-two"])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(MainButton, {
              title: _ctx.$t('common.sake'),
              activeStatus: isMainButtonActive.value,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (withdrawRef.value?.confirmWithdraw()))
            }, null, 8, ["title", "activeStatus"])
          ])
        ])),
    (_unref(userStore).isEnableWithdrawNotice && _ctx.dataSet?.withdrawControls?.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('common.notice')), 1),
          _createVNode(_component_van_row, { class: "tabelHeader" }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, {
                span: "12",
                class: "tabeldata"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('withdraw.rechargeTimes')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: "12",
                class: "tabeldata"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('withdraw.rechargeAmount')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet?.withdrawControls, (item, index) => {
            return (_openBlock(), _createBlock(_component_van_row, {
              key: index,
              class: _normalizeClass(index % 2 === 0 ? 'row-dark' : 'row-light')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, {
                  span: "12",
                  class: "tabeldata"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.rechargeTime) + " X", 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_van_col, {
                  span: "12",
                  class: "tabeldata"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.minAmount), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["class"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})